import { fabric } from "fabric";
export type PointOrNull = fabric.Point | null;

export function valBetweenPoints(
  tab: any[],
  indDeb: number,
  sens: string,
  indFin: number
) {
  const indexTab = tab.map((_, index) => index);
  const startIndexTab = indexTab.slice(indDeb);

  let returnValue = [];

  if (sens === "right") {
    if (startIndexTab.indexOf(indFin) !== -1) {
      returnValue = tab.slice(indDeb, indFin + 1);
    } else {
      const endTab = tab.slice(0, indFin + 1);
      const startTab = tab.slice(indDeb);
      returnValue = [...startTab, ...endTab];
    }
  } else {
    if (indDeb < indFin) {
      returnValue = [
        ...tab.slice(0, indDeb + 1).reverse(),
        ...tab.slice(indFin).reverse(),
      ];
    } else {
      returnValue = tab.slice(indFin, indDeb + 1);
    }
  }

  return returnValue;
}

export function getSensSelectedPoints(
  start: number,
  sens: number,
  end: number,
  length: number
) {
  const tab = Array.from({ length }, (_, index) => index);
  const newTab =
    start > 0 ? [...tab.slice(start), ...tab.slice(0, start)] : tab;

  let direction = "";
  if (newTab.indexOf(end) > newTab.indexOf(sens)) {
    direction = "right";
  } else {
    direction = "left";
  }

  return direction;
}

export function insertTable(
  tabSource: any[],
  index: number,
  tabDestination: any[]
) {
  const tabSourceCopy = [...tabSource];
  const tabDestCopy = [...tabDestination];

  // Retourner les éléments du tableau source dans le tableau de destination à l'index donné
  tabSourceCopy.splice(index, 0, ...tabDestCopy);
  return tabSourceCopy;
}

export const replaceValueswithNull = (
  table1: fabric.Point[],
  table2: fabric.Point[]
) => {
  // Créer une copie du tableau1 pour ne pas modifier l'original
  const newTable: PointOrNull[] = [...table1];

  // Parcourir le tableau1
  newTable.forEach((valeur, index) => {
    // Vérifier si la valeur se trouve également dans le tableau2
    if (table2.includes(valeur as fabric.Point)) {
      // Remplacer la valeur par null
      newTable[index] = null;
    }
  });

  return newTable;
};

export function AreSegmentsCrossing(
  segment1: [fabric.Point, fabric.Point],
  segment2: [fabric.Point, fabric.Point]
): boolean {
  const [a, b] = segment1;
  const [c, d] = segment2;

  // Fonction pour déterminer l'orientation de triplet (a, b, c)
  function orientation(p1: fabric.Point, p2: fabric.Point, p3: fabric.Point): number {
    return (p2.y - p1.y) * (p3.x - p2.x) - (p3.y - p2.y) * (p2.x - p1.x);
  }

  // Vérifier si les points c et d sont du côté différent de la ligne a-b
  const orientation1 = orientation(a, b, c);
  const orientation2 = orientation(a, b, d);
  const orientation3 = orientation(c, d, a);
  const orientation4 = orientation(c, d, b);

  // Si les orientations changent, les segments se croisent
  if (
    (orientation1 > 0 && orientation2 < 0) ||
    (orientation1 < 0 && orientation2 > 0)
  ) {
    if (
      (orientation3 > 0 && orientation4 < 0) ||
      (orientation3 < 0 && orientation4 > 0)
    ) {
      return true;
    }
  }

  return false;
}

export function IsPolygonCrossing(polygone: fabric.Point[]): boolean {
  const n = polygone.length;
  if (n < 4) return false; // Un polygone avec moins de 3 sommets ne peut pas se croiser

  for (let i = 0; i < n; i++) {
    const segment1: [fabric.Point, fabric.Point] = [polygone[i], polygone[(i + 1) % n]];
    for (let j = i + 1; j < n; j++) {
      const segment2: [fabric.Point, fabric.Point] = [polygone[j], polygone[(j + 1) % n]];
      if (AreSegmentsCrossing(segment1, segment2)) {
        return true;
      }
    }
  }

  return false;
}
